import { ToggleButton, ToggleButtonGroup } from '@mui/lab';
import CropSquareIcon from '@mui/icons-material/CropSquare';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import EditIcon from '@mui/icons-material/Edit';
import React from 'react';
import { useMainToolbarStyles } from 'components/ImageViewer/styles';
import { useDrawingToolButtonStyles } from 'components/ImageViewer/components/ImageViewerToolbar/styles';
import { DRAWING_TOOLS_TOOLTIPS } from 'components/ImageViewer/components/ImageViewerToolbar/constants';

export const DrawingToolsButtonGroup = ({
  handleDrawerToolChange,
  selectedDrawTool,
}) => {
  const { classes: mainToolbarClasses } = useMainToolbarStyles();
  const { classes: drawToolButtonClasses } = useDrawingToolButtonStyles();

  const buttonClassName = `${drawToolButtonClasses.buttonWrapper} ${mainToolbarClasses.defaultButton}`;
  // Polygon is no longer in the palette; older preferences show the square.
  const activeTool = selectedDrawTool === 'polygon' ? 'rect' : selectedDrawTool;

  return (
    <ToggleButtonGroup
      onChange={handleDrawerToolChange}
      exclusive
      value={activeTool}
    >
      <ToggleButton
        value="rect"
        size="small"
        title={DRAWING_TOOLS_TOOLTIPS.SQUARE}
        className={buttonClassName}
      >
        <CropSquareIcon fontSize="small" />
      </ToggleButton>
      <ToggleButton
        value="ellipse"
        size="small"
        title={DRAWING_TOOLS_TOOLTIPS.CIRCLE}
        className={buttonClassName}
      >
        <RadioButtonUncheckedIcon fontSize="small" />
      </ToggleButton>
      <ToggleButton
        value="freehand"
        size="small"
        title={DRAWING_TOOLS_TOOLTIPS.PENCIL}
        className={buttonClassName}
      >
        <EditIcon fontSize="small" />
      </ToggleButton>
    </ToggleButtonGroup>
  );
};
